module.exports = __webpack_public_path__ + "img/29.2.TN.0fd0a4ba.png";